<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div class="card">
          <div class="card-content">
            <settings-form :disabled-settings="[]" />
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import SettingsForm from './Partials/SettingsForm'

export default {
  components: {SettingsForm},
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings.vue